import styled from "@emotion/styled"
import MoreVertIcon from "@mui/icons-material/MoreVert"
import { Box, Menu, MenuItem, useTheme } from "@mui/material"
// import { getDesignTokens } from 'configs/theme';
import { BASIC_ACTION } from "@/utils/util"
import React, { ReactNode, useState } from "react"
import { hexToRgba } from "@/Components/helpers/util"
// import { useAppSelector } from 'redux-store/hooks';

type ActionItem = {
  value: string
  label?: string
  disabled?: boolean
  hidden?: boolean
  color?: string
}

type Props = {
  onAction: (
    data: Record<string, string | number | boolean> | unknown,
    action: string
  ) => void
  dataItem?: unknown
  actionList?: ActionItem[]
  icon?: ReactNode
  disabled?: boolean
}

const ActionWrap = styled(Box)(() => ({
  justifyContent: "center",
  width: "100%",
  display: "flex",
}))

const ActionIcon = styled(Box)(() => ({
  cursor: "pointer",
  color: "#939EC7",
}))

const MenuStyled = styled(Menu)(() => {
  return {
    "& ul": {
      backgroundColor: "#fff",
      "& li": {
        backgroundColor: "#fff",
        color: "#0D1F60",
      },
    },
  }
})

const TableAction = (props: Props) => {
  // const { theme, otherTheme } = useAppSelector((state) => state.app);
  // const designToken = getDesignTokens(theme, otherTheme);
  const theme = useTheme()
  const actionDefault: ActionItem[] = [
    {
      // label: t(`common:button.${BASIC_ACTION.EDIT}`),
      label: "Edit Details",
      value: BASIC_ACTION.EDIT,
    },
    {
      // label: t(`common:button.${BASIC_ACTION.VIEW}`),
      label: "View Data",
      value: BASIC_ACTION.VIEW,
    },

    {
      // label: t(`common:button.${BASIC_ACTION.DELETE}`),
      label: "Delete Data Collection",
      value: BASIC_ACTION.DELETE,
    },
    // {
    // 	// label: t(`common:button.${BASIC_ACTION.DELETE}`),
    // 	value: BASIC_ACTION.ADDRECORD,
    // },
  ]

  const {
    dataItem,
    actionList = actionDefault,
    onAction,
    icon = <MoreVertIcon />,
    disabled,
  } = props

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)

  const handleOpenDropdown = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation()
    setAnchorEl(event.currentTarget)
  }

  const handleOnClick = (action: string) => {
    setAnchorEl(null)
    onAction(dataItem, action)
  }

  return (
    <>
      <ActionWrap
        onClick={(event: React.MouseEvent<HTMLElement>) =>
          handleOpenDropdown(event)
        }
        id="snr-ai-table-action"
      >
        <ActionIcon>{icon}</ActionIcon>
      </ActionWrap>
      {open && (
        <MenuStyled
          disableScrollLock
          anchorEl={anchorEl}
          open={open}
          onClose={(e: React.MouseEvent<HTMLElement>) => {
            e.stopPropagation()
            setAnchorEl(null)
          }}
        >
          {actionList?.map((option, index) => {
            return (
              !option?.hidden && (
                <MenuItem
                  key={`${option.value}-${index}`}
                  onClick={(e) => {
                    e.stopPropagation()
                    handleOnClick(option?.value)
                  }}
                  style={{ textTransform: "capitalize" }}
                  disabled={option?.disabled || disabled}
                  sx={{
                    color: `${option?.color}!important` || "#0D1F60",
                    fontSize: "13px",
                    "&:hover": {
                      background: hexToRgba(theme.palette.primary.main, 0.05),
                    },
                  }}
                  id={"snr-ai-table-action-" + option?.value}
                >
                  {option?.label || option?.value}
                </MenuItem>
              )
            )
          })}
        </MenuStyled>
      )}
    </>
  )
}

export default TableAction
